import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-row justify-center gap-2" }
const _hoisted_3 = { class: "inline-text" }
const _hoisted_4 = { class: "inline-text" }
const _hoisted_5 = {
  key: 0,
  class: "inline-text"
}
const _hoisted_6 = { class: "inline-text" }
const _hoisted_7 = { class: "inline-text" }
const _hoisted_8 = { class: "flex flex-col mt-4 w-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, " Note legali e declinazione di responsabilità: Tutti i risultati dei calcoli della presente sezioni sono fornite a soli fini di supporto. I risultati non devono essere utilizzati per sostituire la valutazione medica. LE PRESENTI INFORMAZIONI NON SONO SOSTITUTIVE DEL GIUDIZIO CLINICO NÉ MIRANO A ORIENTARE LA CURA INDIVIDUALE DEI PAZIENTI IN ALCUN MODO. ", -1)
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center mt-4" }

import { hasPermission } from "../../../../EshJSLib/services/securityServices";
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { ColumnModel } from "@/../../EshJSLib/models/ColumnModel";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";

import dosiInBaseAlPeso from "@/../../EshJSLib/models/form/dosiInBaseAlPeso.json";
import dosiVelocitaInfusione from "@/../../EshJSLib/models/form/dosiVelocitaInfusione.json";
import dosiGoccieMillilitri from "@/../../EshJSLib/models/form/dosiGoccieMililitri.json";

import calcolaGault from "@/../../EshJSLib/models/form/calcolaGault.json";
import calcolaCreat from "@/../../EshJSLib/models/form/calcolaCreat.json";
import calcolaEquazione from "@/../../EshJSLib/models/form/calcolaEquazione.json";

import baseAlPesoCalculator from "./DosiSection/baseAlPesoCalculator.vue";
import velocitaInfusioneCalculator from "./DosiSection/velocitaInfusioneCalculator.vue";
import gocceMilillitriCalculator from "./DosiSection/gocceMilillitriCalculator.vue";

import creatCalculator from "./ClearanceSection/creatCalculator.vue";
import equazioneCalculator from "./ClearanceSection/equazioneCalculator.vue";
import gaultCalculator from "./ClearanceSection/gaultCalculator.vue";
import CalculatorDescription from "./components/CalculatorDescription.vue";
import ScoresLink from "./components/ScoresLink.vue";

import { onMounted, ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";

import BaseInput from "./components/BaseInput.vue";
import { RouterLink, routerViewLocationKey } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalcolatriceMedica',
  setup(__props) {

const store = patientStore();
const { patient } = storeToRefs(store);

const router = useRouter();
const isShownModalSub = reactive({
  alert: false,
  movePage: false,
  confirm: false,
  alertMove: false,
});

function movePage() {
  router.push({ path: '/Registro/Paypal' })
}

function movePageHome() {
  router.go(-1)
}

let creatininemia = ref(1);
let peso = ref(patient.value.tbl_parametri_vitalis[0].parametro_peso);
let altezza = ref(patient.value.tbl_parametri_vitalis[0].parametro_altezza);
let sesso = patient.value.paziente_sesso;
let eta = patient.value.paziente_eta;

let pesoValid = ref(" ");
let altezzaValid = ref(" ");
let creatinemiaValid = ref(" ");

let BMI = (peso.value / ((altezza.value * altezza.value) / 10000)).toFixed(2)
let BMIvalue = ref(BMI);

const powerAltezza = Math.pow(altezza.value, 0.725);
const powerPeso = Math.pow(peso.value, 0.425);
let BSA = (0.007184 * powerAltezza * powerPeso).toPrecision(3);
let BSAvalue = ref(BSA);

onMounted(async () => {
  if (await hasPermission('calcolatrice')) {
    store.fetchHasBledScoresRelatedData();
    store.fetchCha2Ds2ScoresRelatedData();
    store.fetchMeldScoresRelatedData();
    store.fetchFraminghamScoresRelatedData();
    store.fetchCardiovascolareRelatedData();
  } else {
    isShownModalSub.alert = true;
  }
});

function checkInputValidity() {
  if (peso.value < 5 || peso.value > 400) {
    pesoValid.value =
      "Inserisci un valore valido per il peso. Il valore deve essere compreso tra 5 e 400.";
  } else {
    BMIvalue.value = (+peso.value / ((+altezza.value * +altezza.value) / 10000)).toFixed(2)
    BSAvalue.value = (0.007184 * (Math.pow(+altezza.value, 0.725)) * (Math.pow(+peso.value, 0.425))).toPrecision(3);
    pesoValid.value = " ";
  }
  if (altezza.value < 50 || altezza.value > 220) {
    altezzaValid.value =
      "Inserisci un valore valido per l'altezza. Il valore deve essere compreso tra 50 e 220.";
  } else {
    altezzaValid.value = " ";
    BMIvalue.value = (+peso.value / ((+altezza.value * +altezza.value) / 10000)).toFixed(2)
    BSAvalue.value = (0.007184 * (Math.pow(+altezza.value, 0.725)) * (Math.pow(+peso.value, 0.425))).toPrecision(3);
  }
  if (creatininemia.value < 0.1 || creatininemia.value > 13) {
    creatinemiaValid.value =
      "Inserisci un valore valido per la creatinemia. Il valore deve essere compreso tra 0.1 e 13.";
  } else {
    creatinemiaValid.value = " ";
  }
}

const dataModelCompletati = new CollapsableModel();

return (_ctx: any,_cache: any) => {
  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(BaseInput, {
              style: {"width":"150px"},
              label: "Peso (in kg)",
              placeholder: "50",
              type: "number",
              step: "0.1",
              lang: "it",
              modelValue: _unref(peso),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(peso) ? (peso).value = $event : peso = $event)),
              onValidateInput: checkInputValidity,
              isInputValid: _unref(pesoValid)
            }, null, 8, ["modelValue", "isInputValid"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(BaseInput, {
              style: {"width":"150px"},
              label: "Altezza (in cm)",
              placeholder: "50",
              step: "0.1",
              lang: "it",
              type: "number",
              modelValue: _unref(altezza),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(altezza) ? (altezza).value = $event : altezza = $event)),
              onValidateInput: checkInputValidity,
              isInputValid: _unref(altezzaValid)
            }, null, 8, ["modelValue", "isInputValid"])
          ]),
          (_ctx.$route.fullPath == '/CalcolatriceMedica/Clearance')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BaseInput, {
              label: "Indice di massa corporea BMI",
              style: {"width":"150px"},
              type: "number",
              value: _unref(BMIvalue),
              disabled: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseInput, {
              label: "Superficie corporea",
              style: {"width":"150px"},
              type: "number",
              value: _unref(BSAvalue),
              disabled: ""
            }, null, 8, ["value"])
          ])
        ]),
        (_ctx.$route.fullPath == '/CalcolatriceMedica/Dosi')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(CollapsibleItem, { data: _unref(dosiInBaseAlPeso) }, {
                default: _withCtx(() => [
                  _createVNode(baseAlPesoCalculator, {
                    peso: _unref(peso),
                    altezza: _unref(altezza)
                  }, null, 8, ["peso", "altezza"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(CollapsibleItem, { data: _unref(dosiVelocitaInfusione) }, {
                default: _withCtx(() => [
                  _createVNode(velocitaInfusioneCalculator, { peso: _unref(peso) }, null, 8, ["peso"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(CollapsibleItem, { data: _unref(dosiGoccieMillilitri) }, {
                default: _withCtx(() => [
                  _createVNode(gocceMilillitriCalculator)
                ]),
                _: 1
              }, 8, ["data"])
            ], 64))
          : (_ctx.$route.fullPath == '/CalcolatriceMedica/Clearance')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(CollapsibleItem, { data: _unref(calcolaGault) }, {
                  default: _withCtx(() => [
                    _createVNode(gaultCalculator, {
                      altezza: _unref(altezza),
                      eta: _unref(eta),
                      peso: _unref(peso),
                      creatininemia: _unref(creatininemia),
                      sesso: _unref(sesso)
                    }, null, 8, ["altezza", "eta", "peso", "creatininemia", "sesso"])
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(CollapsibleItem, { data: _unref(calcolaCreat) }, {
                  default: _withCtx(() => [
                    _createVNode(creatCalculator, { creatininemia: _unref(creatininemia) }, null, 8, ["creatininemia"])
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(CollapsibleItem, { data: _unref(calcolaEquazione) }, {
                  default: _withCtx(() => [
                    _createVNode(equazioneCalculator, {
                      creatininemia: _unref(creatininemia),
                      sesso: _unref(sesso),
                      eta: _unref(eta)
                    }, null, 8, ["creatininemia", "sesso", "eta"])
                  ]),
                  _: 1
                }, 8, ["data"])
              ], 64))
            : (_ctx.$route.fullPath == '/CalcolatriceMedica/calcoloScores')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(CalculatorDescription, { "calculator-description": "Di seguito si mettono a disposizione Scores calcolabili sulla base dei dati di un paziente" }),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(RouterLink), {
                      to: "/calcolatricemedica/calcoloScores/hasBledScore",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ScoresLink, {
                          class: "w-full",
                          title: "HAS-BLED Score"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(RouterLink), {
                      to: "/calcolatricemedica/calcoloScores/chaDsVasScore",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ScoresLink, {
                          class: "w-full",
                          title: "CHA₂DS₂-VASc Score"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(RouterLink), {
                      to: "/calcolatricemedica/calcoloScores/framinghamScore",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ScoresLink, {
                          class: "w-full",
                          title: "Framingham Risk Score"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(RouterLink), {
                      to: "/calcolatricemedica/calcoloScores/meldScore",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ScoresLink, {
                          class: "w-full",
                          title: "MELD Score"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(RouterLink), {
                      to: "/calcolatricemedica/calcoloScores/cardiovascolareScore",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ScoresLink, {
                          class: "w-full",
                          title: "Score Cardiovascolare"
                        })
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : _createCommentVNode("", true),
        _hoisted_9,
        (isShownModalSub.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 3,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (movePageHome()))
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (movePageHome())),
                    type: "button",
                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (movePage())),
                    type: "button",
                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})